// extracted by mini-css-extract-plugin
export default {"header":"style_header__ZdHEl","subheader":"style_subheader__FT64a","numbers":"style_numbers__R5EbY","floatingLabel":"style_floatingLabel__efewy"};